import { times } from "lodash-es"

import {
  Order,
  PartialNcsConfig,
  defaultKwicConfig,
  defaultFullFrequencyConfig,
  defaultFilterConfig,
  defaultOrder,
} from "ncs"

const groupsConfig = {
  'documents.siglo': {
    filters: ['documents.ano_desde', 'documents.ano_hasta'],
    getValues: (v: string) => [(parseInt(v) - 1) * 100 + 1, parseInt(v) * 100],
    sortBy: v => !v ? null : parseInt(v)
  }
}

const frequencyGroupOrder = [
  "documents.otorgante",
  "documents.siglo",
]

const documentOrders: Order[] = [
  { name: "documents.fecha_ordenacion", criteria: [{ field: "documents.fecha_ordenacion", asc: true }] },
  { name: "documents.otorgante", criteria: [{ field: "documents.otorgante", asc: true }] },
]

function compareFilterValues(a: { label: string, value: unknown }, b: { label: string, value: unknown }) {
  if (a.label === "Non aplica") return 1
  if (b.label === "Non aplica") return -1

  return a.label.localeCompare(b.label)
}

function fieldOrder(n, asc, type, field): Order {
  return {
    name: field,
    criteria: [
      ...times(n, i => ({ field: `l.${field}${i + 1}`, asc, type })),
      ...times(n, i => ({ field: `r.${field}${i + 1}`, asc, type }))
    ]
  }
}

export const ncsConfig: PartialNcsConfig = {
  elements: {
    types: ["units"],
    maximumSensitivities: 99,
    sensitivities: {
      case: false,
      ij: false,
      uv: false,
      and_et: false,
    }
  },
  filters: [
    ...defaultFilterConfig,
    { field: "documents.otorgante" },
    { field: "documents.bibliografia_titulo" },
    { field: "documents.bibliografia_autor" },
    { field: "documents.bibliografia_editorial" },
    { id: "documents.ano_desde", field: "documents.ano", operator: "gteq" },
    { id: "documents.ano_hasta", field: "documents.ano", operator: "lteq" },
  ],
  result: {
    defaultType: "kwic",
    error: {
      contactLink: "./contacto",
      contactEmail: "soporte@nlpgo.com"
    },
    types: ["frequency", "full_frequency", "kwic"]
  },
  queries: {
    kwic: {
      ...defaultKwicConfig,
      order: {
        orders: [...defaultOrder(5), ...documentOrders],
        default: ["documents.fecha_ordenacion", "matching"]
      }
    },
    full_frequency: {
      ...defaultFullFrequencyConfig,
      groups: groupsConfig,
      frequencyGroupOrder
    },
  }
}
